import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/images/sam_brand.png'
import _imports_1 from './assets/images/sam_close_up.jpg'
import _imports_2 from './assets/images/icn_zwift_Icon.svg'
import _imports_3 from './assets/images/stockwise.png'
import _imports_4 from './assets/images/spotpass.svg'
import _imports_5 from './assets/images/letterlock-feature.png'
import _imports_6 from './assets/images/polaroid-collage.webp'
import _imports_7 from './assets/images/holographic-plant.png'


const _hoisted_1 = {
  ref: "homePage",
  id: "portfolio"
}
const _hoisted_2 = {
  id: "navbar",
  class: "navbar navbar-light"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-nav" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"icon-links-fixed\"><ul class=\"icon-links\"><li><a href=\"https://github.com/sammyshows\" target=\"_blank\"><span class=\"iconify\" data-icon=\"codicon:github-alt\" data-inline=\"false\"></span></a></li><li><a href=\"https://www.linkedin.com/in/sam-mccarthy-dev/\" target=\"_blank\"><span class=\"iconify\" data-icon=\"eva:linkedin-outline\" data-inline=\"false\"></span></a></li></ul></div><div class=\"email-fixed\"><a href=\"mailto: samrmccarthy6@gmail.com\"><p>samrmccarthy6@gmail.com</p></a></div>", 2)
const _hoisted_10 = { class: "welcome-page" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"welcome-container\"><p class=\"welcome-first\">G&#39;day, my name is</p><h2 class=\"r-link animated-underline animated-underline_type5 welcome-name\">Sam McCarthy.</h2><h3 class=\"welcome-quote\">I love to build things.</h3><div class=\"welcome-intro\"><p class=\"r-link animated-underline animated-underline_type4\">I&#39;m a passionate software engineer focused on building high-quality, modern digital experiences.</p></div></div><section id=\"section07\" class=\"demo\"><a href=\"#section08\"><span></span><span></span><span></span></a></section>", 2)
const _hoisted_13 = {
  ref: "aboutPage",
  class: "about-page"
}
const _hoisted_14 = { class: "about-container" }
const _hoisted_15 = { class: "page-title" }
const _hoisted_16 = { class: "about-content" }
const _hoisted_17 = { class: "about-text-content" }
const _hoisted_18 = { class: "about-text-form-section" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", {
  style: {"color":"#A1C8FF","font-size":"15px"},
  class: "mb-2 sm:mb-4"
}, "Adjust bio length:", -1)
const _hoisted_20 = { class: "about-text-form" }
const _hoisted_21 = ["onClick", "checked"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-size-options" }, [
  /*#__PURE__*/_createElementVNode("h5", { style: {"color":"#A1C8FF","font-size":"15px"} }, "Shortest"),
  /*#__PURE__*/_createElementVNode("h5", { style: {"color":"#A1C8FF","font-size":"15px"} }, "Longest")
], -1)
const _hoisted_23 = { class: "about-text" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", { style: {"font-weight":"700","color":"#A1C8FF"} }, "Sam McCarthy", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#A1C8FF"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "grooviest")
], -1)
const _hoisted_27 = { style: {"color":"#A1C8FF"} }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "exceptional", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { style: {"color":"#A1C8FF"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "motivation", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { style: {"color":"#A1C8FF"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "collaborating", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, ", but ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#A1C8FF"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "YOU")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "about-image-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "relative object-cover",
    src: _imports_1,
    alt: "sam mccarthy close up"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "about-image-overlay" }),
  /*#__PURE__*/_createElementVNode("div", { class: "about-image-border" })
], -1)
const _hoisted_39 = {
  ref: "experiencePage",
  class: "experience-page"
}
const _hoisted_40 = { class: "page-title experience-title" }
const _hoisted_41 = { class: "project-card experience-card experience-card-right mt-0 sm:mt-20" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "experience-links hidden sm:flex" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://zwift.com.au/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "iconify",
      "data-icon": "feather:external-link",
      "data-inline": "false"
    })
  ])
], -1)
const _hoisted_43 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createTextVNode(" Zwift International provides a comprehensive online ordering platform for the hospitality industry."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" As the lead developer of the product team, I've had the pleasure of spearheading projects such as building internal AI tools, business-facing applications on Windows, Mac, and Android, POS & KDS systems, staff intranet, online ordering website, and much more. ")
  ])
], -1)
const _hoisted_45 = {
  class: "experience-skills-right hidden sm:block",
  style: {"margin-bottom":"20px"}
}
const _hoisted_46 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_47 = { class: "animated-underline animated-underline_type4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-right" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://zwift.com.au/",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "Zwift International")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "Oct 2022 - Present")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://zwift.com.au/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "experience-logo",
      src: _imports_2,
      alt: "Zwift logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "Zwift International")
], -1)
const _hoisted_51 = { class: "project-card experience-card experience-card-left mt-16 sm:mt-32" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://apps.apple.com/au/app/stockwise/id6444794675",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "experience-logo",
      src: _imports_3,
      alt: "Stockwise logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "Stockwise")
], -1)
const _hoisted_53 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createTextVNode("Following a surge in new stock market investors in 2020, I identified a need for greater education and tools for studying businesses. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("This led to the birth of "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/au/app/stockwise/id6444794675",
      style: {"color":"#A1C8FF"},
      target: "_blank"
    }, "Stockwise"),
    /*#__PURE__*/_createTextVNode(": a mobile-first application enabling users to study companies, track their stock, currency and cash investments, and see deep insights into companies.")
  ])
], -1)
const _hoisted_55 = {
  class: "experience-skills-left hidden sm:block",
  style: {"margin-bottom":"20px"}
}
const _hoisted_56 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_57 = { class: "animated-underline animated-underline_type4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "Apr 2022 - Sep 2022"),
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/au/app/stockwise/id6444794675",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "Stockwise")
  ])
], -1)
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<div class=\"experience-links hidden sm:flex\"><a href=\"https://github.com/sammyshows/\" target=\"_blank\"><span class=\"iconify\" data-icon=\"ant-design:github-filled\" data-inline=\"false\"></span></a><a href=\"https://apps.apple.com/au/app/stockwise/id6444794675\" target=\"_blank\"><span class=\"iconify\" data-icon=\"feather:external-link\" data-inline=\"false\"></span></a></div>", 1)
const _hoisted_61 = { class: "project-card experience-card experience-card-right mt-16 sm:mt-32" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "experience-links hidden sm:flex" }, null, -1)
const _hoisted_63 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://spotpass.com/",
      style: {"color":"#A1C8FF"},
      target: "_blank"
    }, "Spotpass"),
    /*#__PURE__*/_createTextVNode(" is a micropayment system designed to allow everyone to get instant access to their favourite content for 99c or less."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Being the sole Front End Developer at Spotpass, I was tasked with building applications from the ground up including our internal admin portal and producer portal. I was also responsible for adding new features to our web applications and maintaining our consumer flow.")
  ])
], -1)
const _hoisted_65 = { class: "experience-skills-right hidden sm:block" }
const _hoisted_66 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_67 = { class: "animated-underline animated-underline_type4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-right" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://spotpass.com/",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "Spotpass")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "Jun 2021 - Mar 2022")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://spotpass.com/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "experience-logo",
      src: _imports_4,
      alt: "Spotpass button"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "Spotpass")
], -1)
const _hoisted_71 = {
  ref: "projectPage",
  class: "project-page pt-5"
}
const _hoisted_72 = { class: "project-container" }
const _hoisted_73 = {
  class: "page-title",
  style: {"margin-top":"5vh"}
}
const _hoisted_74 = { class: "project-cards" }
const _hoisted_75 = { class: "project-card experience-card experience-card-left mt-20" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://apps.apple.com/au/app/letterlock-puzzle/id6450538544",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-80 experience-logo rounded-lg sm:rounded-xl",
      src: _imports_5,
      alt: "Letterlock logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "LetterLock")
], -1)
const _hoisted_77 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/au/app/letterlock-puzzle/id6450538544",
      style: {"color":"#A1C8FF"},
      target: "_blank"
    }, "LetterLock"),
    /*#__PURE__*/_createTextVNode(" is a mobile puzzle game available on iOS and Android."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" It's a very fun and challenging original concept where letters must be shuffled to form the required words in limited moves."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I was the sole developer on this project and was responsible for the entire front end and back end development, as well as game design and marketing. ")
  ])
], -1)
const _hoisted_79 = { class: "experience-skills-left hidden sm:block" }
const _hoisted_80 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_81 = { class: "animated-underline animated-underline_type4" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/au/app/letterlock-puzzle/id6450538544",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "LetterLock")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "May 2023 - Jul 2023")
], -1)
const _hoisted_84 = /*#__PURE__*/_createStaticVNode("<div class=\"experience-links hidden sm:flex\"><a href=\"https://github.com/sammyshows/\" target=\"_blank\"><span class=\"iconify\" data-icon=\"ant-design:github-filled\" data-inline=\"false\"></span></a><a href=\"https://apps.apple.com/au/app/letterlock-puzzle/id6450538544\" target=\"_blank\"><span class=\"iconify\" data-icon=\"feather:external-link\" data-inline=\"false\"></span></a></div>", 1)
const _hoisted_85 = { class: "project-card experience-card experience-card-right mt-16 sm:mt-32" }
const _hoisted_86 = /*#__PURE__*/_createStaticVNode("<div class=\"experience-links hidden sm:flex\"><a href=\"https://github.com/sammyshows/\" target=\"_blank\"><span class=\"iconify\" data-icon=\"ant-design:github-filled\" data-inline=\"false\"></span></a><a href=\"https://ugcwithceline.com\" target=\"_blank\"><span class=\"iconify\" data-icon=\"feather:external-link\" data-inline=\"false\"></span></a></div>", 1)
const _hoisted_87 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createTextVNode(" With a passion for creative storytelling and a keen eye for detail, Celine helps brands connect with their audience through engaging and authentic content. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Whether it's through eye-catching photography or compelling videos, her goal is to bring each brand's unique voice to life and make it resonate with their target audience. ")
  ])
], -1)
const _hoisted_89 = {
  class: "experience-skills-right hidden sm:block",
  style: {"margin-bottom":"20px"}
}
const _hoisted_90 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_91 = { class: "animated-underline animated-underline_type4" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "Apr 2022 - Sep 2022"),
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://ugcwithceline.com",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "UGC with Celine")
  ])
], -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://ugcwithceline.com",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "experience-logo",
      src: _imports_6,
      alt: "Stockwise logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "UGC with Celine")
], -1)
const _hoisted_95 = { class: "project-card experience-card experience-card-left mt-20" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center gap-x-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://xembee.netlify.app",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "experience-logo rounded-lg sm:rounded-xl",
      src: _imports_7,
      alt: "Letterlock logo"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h2", {
    class: "text-3xl sm:hidden",
    style: {"font-weight":"100"}
  }, "LetterLock")
], -1)
const _hoisted_97 = {
  class: "project-text",
  style: {"z-index":"2"}
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "experience-text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","margin":"0","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://xembee.netlify.app",
      style: {"color":"#A1C8FF"},
      target: "_blank"
    }, "XEMBEE"),
    /*#__PURE__*/_createTextVNode(" is pioneering the future of wind energy with cutting-edge wind panels that convert natural breezes into affordable, sustainable power. With over a decade of advanced research, XEMBEE leads the charge in transforming how we harness and utilize wind energy. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Their innovative solutions not only push the boundaries of traditional wind energy standards but also contribute positively to energy production while maintaining a minimal environmental footprint. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Inspired by nature, from bees to fish, and from birds to trees, XEMBEE's technology is designed to be durable, efficient, and adaptable to meet a variety of energy needs. ")
  ])
], -1)
const _hoisted_99 = { class: "experience-skills-left hidden sm:block" }
const _hoisted_100 = {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}
const _hoisted_101 = { class: "animated-underline animated-underline_type4" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"12px","font-weight":"700","text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"},
  class: "r-link"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "animated-underline animated-underline_type4" }, "Figma")
], -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "experience-title-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"45px","font-weight":"100","border-bottom":"3px #A1C8FF solid"} }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://xembee.netlify.app",
      style: {"color":"white","text-decoration":"none"},
      target: "_blank"
    }, "XEMBEE")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"100"} }, "May 2023 - Jul 2023")
], -1)
const _hoisted_104 = /*#__PURE__*/_createStaticVNode("<div class=\"experience-links hidden sm:flex\"><a href=\"https://github.com/sammyshows/\" target=\"_blank\"><span class=\"iconify\" data-icon=\"ant-design:github-filled\" data-inline=\"false\"></span></a><a href=\"https://xembee.netlify.app\" target=\"_blank\"><span class=\"iconify\" data-icon=\"feather:external-link\" data-inline=\"false\"></span></a></div>", 1)
const _hoisted_105 = {
  ref: "contactPage",
  class: "contact-page"
}
const _hoisted_106 = { class: "contact-container" }
const _hoisted_107 = { class: "page-title" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "contact-text" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"text-shadow":"1px 1px 3px rgba(0,0,0,0.2)"} }, "I'm currently interested in new opportunities. I'm always keen to have a chat - whether you have a question or want to grab a coffee, please feel free to reach out!")
], -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("a", { href: "mailto: samrmccarthy6@gmail.com" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "contact-button" }, "Say Hello")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTo('homePage'))),
        class: "brand-image",
        style: {"cursor":"pointer"}
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (navLink) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: ($event: any) => (_ctx.scrollTo(navLink.element)),
            class: "nav-item nav-link r-link animated-underline animated-underline_type4 hidden sm:flex",
            style: {"cursor":"pointer","font-weight":"300","color":"#A1C8FF"}
          }, _toDisplayString(navLink.name), 9, _hoisted_6))
        }), 256)),
        _createElementVNode("a", {
          class: "nav-item nav-link",
          id: "navbar-resume-link",
          style: {"font-weight":"300","color":"white","border":"1px #A1C8FF solid","padding-left":"20px","padding-right":"20px","transition":"0.3s","border-radius":"4px"},
          href: `${_ctx.publicPath}sam-mccarthy-software-engineer.pdf`,
          target: "_blank",
          download: ""
        }, "Resume", 8, _hoisted_7)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollTo('aboutPage'))),
        class: "arrow-button"
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h1", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTo('aboutPage'))),
            id: "about-page-title",
            style: {"font-weight":"100"}
          }, "About")
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                  return _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      style: {"cursor":"pointer"},
                      type: "radio",
                      name: "radio",
                      onClick: ($event: any) => (_ctx.setBioLength(index)),
                      checked: _ctx.bioLength === index
                    }, null, 8, _hoisted_21)
                  ])
                }), 64))
              ]),
              _hoisted_22
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(" is "),
              (_ctx.bioLength > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createTextVNode(" a software engineer"),
                    _withDirectives(_createElementVNode("span", null, ",", 512), [
                      [_vShow, _ctx.bioLength === 2]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createTextVNode(" a tech enthusiast, the absolute "),
                      _hoisted_26,
                      _createTextVNode(", and")
                    ], 512), [
                      [_vShow, _ctx.bioLength === 2]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createTextVNode(" specialised in building "),
                      _withDirectives(_createElementVNode("span", _hoisted_27, _hoisted_29, 512), [
                        [_vShow, _ctx.bioLength === 4 || _ctx.bioLength === 6]
                      ]),
                      _withDirectives(_createElementVNode("span", null, "exceptional", 512), [
                        [_vShow, _ctx.bioLength === 3 || _ctx.bioLength === 5]
                      ]),
                      _createTextVNode(" digital experiences. ")
                    ], 512), [
                      [_vShow, _ctx.bioLength > 2]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createTextVNode("What drives Sam is a passion for tech, excitement for growth and the "),
                      _withDirectives(_createElementVNode("span", _hoisted_30, _hoisted_32, 512), [
                        [_vShow, _ctx.bioLength > 4]
                      ]),
                      _withDirectives(_createElementVNode("span", null, "motivation", 512), [
                        [_vShow, _ctx.bioLength === 4]
                      ]),
                      _createTextVNode(" to excel.")
                    ], 512), [
                      [_vShow, _ctx.bioLength > 3]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createTextVNode(" He loves to spend his time coding and "),
                      _withDirectives(_createElementVNode("span", _hoisted_33, _hoisted_35, 512), [
                        [_vShow, _ctx.bioLength === 3 || _ctx.bioLength === 6]
                      ]),
                      _withDirectives(_createElementVNode("span", null, "collaborating", 512), [
                        [_vShow, _ctx.bioLength === 4 || _ctx.bioLength === 5]
                      ]),
                      _createTextVNode(" with great people"),
                      _hoisted_36
                    ], 512), [
                      [_vShow, _ctx.bioLength > 2]
                    ]),
                    _withDirectives(_createElementVNode("span", null, [
                      _createTextVNode(" ultimately "),
                      _withDirectives(_createElementVNode("span", null, "Sam", 512), [
                        [_vShow, _ctx.bioLength > 2]
                      ]),
                      _createTextVNode(),
                      _withDirectives(_createElementVNode("span", null, "is", 512), [
                        [_vShow, _ctx.bioLength > 2]
                      ])
                    ], 512), [
                      [_vShow, _ctx.bioLength < 4 || _ctx.bioLength === 5]
                    ]),
                    _withDirectives(_createElementVNode("span", null, " at the end of the day Sam is", 512), [
                      [_vShow, _ctx.bioLength === 4 || _ctx.bioLength === 6]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" a problem solver at heart. "),
              _withDirectives(_createElementVNode("span", null, " If you ask Sam what made him into who he is today, he will tell you", 512), [
                [_vShow, _ctx.bioLength > 4]
              ]),
              _withDirectives(_createElementVNode("span", null, " it all starts with good habits.", 512), [
                [_vShow, _ctx.bioLength === 5]
              ]),
              _withDirectives(_createElementVNode("span", null, " it all starts with good habits,", 512), [
                [_vShow, _ctx.bioLength === 6]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _createTextVNode(" ambition and, most importantly, a good system for being the best version of "),
                _hoisted_37,
                _createTextVNode(" everyday.")
              ], 512), [
                [_vShow, _ctx.bioLength === 6]
              ])
            ])
          ]),
          _hoisted_38
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("h1", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollTo('experiencePage'))),
          style: {"font-weight":"100"}
        }, "Experience")
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nuxt3', 'Vue3', 'Node.js', 'TypeScript', 'Linux', 'Electron', 'Capacitor', 'SQL Server', 'CouchDB', '.NET', 'AWS', 'CRON', 'PM2', 'WebSocket', 'TailwindCSS'], (skill) => {
              return _createElementVNode("p", _hoisted_46, [
                _createElementVNode("span", _hoisted_47, _toDisplayString(skill), 1),
                _createTextVNode("   ·    ")
              ])
            }), 64)),
            _hoisted_48
          ]),
          _hoisted_49
        ]),
        _hoisted_50
      ]),
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nuxt3', 'Vue3', 'Node.js', 'TypeScript', 'PostgreSQL', 'TailwindCSS', 'SSR', 'PWA', 'Heroku CRON', 'Netlify Hosting', 'AWS Lambda Functions'], (skill) => {
              return _createElementVNode("p", _hoisted_56, [
                _createElementVNode("span", _hoisted_57, _toDisplayString(skill), 1),
                _createTextVNode("   ·   ")
              ])
            }), 64)),
            _hoisted_58
          ]),
          _hoisted_59
        ]),
        _hoisted_60
      ]),
      _createElementVNode("div", _hoisted_61, [
        _hoisted_62,
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vue3', 'TypeScript', 'GraphQL', 'TailwindCSS', 'Single-spa', 'Scrum', 'Netlify', 'Browserstack'], (skill) => {
              return _createElementVNode("p", _hoisted_66, [
                _createElementVNode("span", _hoisted_67, _toDisplayString(skill), 1),
                _createTextVNode("   ·    ")
              ])
            }), 64)),
            _hoisted_68
          ]),
          _hoisted_69
        ]),
        _hoisted_70
      ])
    ], 512),
    _createElementVNode("div", _hoisted_71, [
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("h1", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollTo('projectPage'))),
            style: {"font-weight":"100"}
          }, "Projects")
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createElementVNode("div", _hoisted_79, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nuxt3', 'Vue3', 'Node.js', 'TypeScript', 'AWS Lambda', 'Capacitor', 'PostgreSQL', 'TailwindCSS', 'iOS', 'Android', 'App Store', 'Play Store'], (skill) => {
                  return _createElementVNode("p", _hoisted_80, [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(skill), 1),
                    _createTextVNode("   ·    ")
                  ])
                }), 64)),
                _hoisted_82
              ]),
              _hoisted_83
            ]),
            _hoisted_84
          ]),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _createElementVNode("div", _hoisted_89, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nuxt3', 'Vue3', 'TypeScript', 'TailwindCSS', 'SSR', 'Image/Video Optimisation'], (skill) => {
                  return _createElementVNode("p", _hoisted_90, [
                    _createElementVNode("span", _hoisted_91, _toDisplayString(skill), 1),
                    _createTextVNode("   ·    ")
                  ])
                }), 64)),
                _hoisted_92
              ]),
              _hoisted_93
            ]),
            _hoisted_94
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("div", _hoisted_99, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Nuxt3', 'Vue3', 'TypeScript', 'PostgreSQL', 'TailwindCSS'], (skill) => {
                  return _createElementVNode("p", _hoisted_100, [
                    _createElementVNode("span", _hoisted_101, _toDisplayString(skill), 1),
                    _createTextVNode("   ·    ")
                  ])
                }), 64)),
                _hoisted_102
              ]),
              _hoisted_103
            ]),
            _hoisted_104
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("h1", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollTo('contactPage'))),
            id: "contact-page-title",
            style: {"font-weight":"100"}
          }, "Say G'Day!")
        ]),
        _hoisted_108,
        _hoisted_109
      ])
    ], 512)
  ], 512))
}